import { getFileType } from './getFileType';

export const flattenDmsList = (list = [], isTraining = false) => {
  const flattenedDmsList = [];

  if (Array.isArray(list) && list.length > 0 && !list[0]?.Image) {
    list.forEach((file) => {
      const fileUrl = file.sFileUrl?.[0] || '';
      const fileName = file.sFileName?.[0] || '';
      const fileType = isTraining && !fileUrl
        ? getFileType(fileName)
        : getFileType(fileUrl);

      const fileInfo = {
        name: file.sName?.[0] || '',
        fileName: fileName,
        fileUrl: fileUrl,
        fileType,
        imageContent: isTraining ? (file.ImageContent?.[0] || '') : undefined,
      };
      flattenedDmsList.push(fileInfo);
    });
    return flattenedDmsList;
  }

  Object.values(list).forEach((files) => {
    if (!Array.isArray(files)) return;
    files.forEach((file) => {

      // In training mode, sFileUrl is empty. Determine file type from fileName
      const fileUrl = file.sFileUrl?.[0] || '';
      const fileName = file.sFileName?.[0] || '';
      const fileType = isTraining && !fileUrl
        ? getFileType(fileName)
        : getFileType(fileUrl);

      const fileInfo = {
        name: file.sName?.[0] || '',
        fileName: fileName,
        fileUrl: fileUrl,
        fileType,
        imageContent: isTraining ? (file.ImageContent?.[0] || '') : undefined,
      };
      flattenedDmsList.push(fileInfo);
    });
  });

  return flattenedDmsList;
};
